/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Bridge Policy resolution statuses.
 */
export type PolicyStatus = (typeof PolicyStatus)[keyof typeof PolicyStatus];

export const PolicyStatus = {
  PENDING: "PENDING",
  UNKNOWN: "UNKNOWN",
  CONFIRMED: "CONFIRMED",
  REVALIDATING: "REVALIDATING",
  INVALID: "INVALID",
} as const;
